module.exports = __webpack_public_path__ + "img/first_fire_operation.d30060f2.png";